export function normalizeImg(url?: string | null, fallback = '/img/badges/acorn.png'): string {
  const value = typeof url === 'string' ? url.trim() : '';
  if (!value) return fallback;
  if (value.startsWith('http')) return value;
  return value.startsWith('/') ? value : `/${value}`;
}
